import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20reading%20atmosphere%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20artistic%20composition%2C%20soft%20focus%2C%20film%20grain%20texture%2C%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20text&width=1600&height=500&seq=hanman-cta-bg&orientation=landscape"
            alt="韩漫阅读氛围"
            className="w-full h-[300px] md:h-[400px] object-cover"
          />
        </div>

        <div className="text-center mt-10 md:mt-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            现在就开启你的
            <br />
            <span className="italic text-foreground-400">韩漫之旅</span>
          </h2>
          <Link
            to="/category"
            className="inline-flex items-center px-10 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors mt-8 whitespace-nowrap cursor-pointer"
          >
            即刻开始阅读
          </Link>
        </div>
      </div>
    </section>
  );
}